
import React, { useState, useEffect } from "react";
import { cn } from "@/lib/utils";
import { CanvasGrid } from "./CanvasGrid";
import { Tool } from "@/hooks/use-canvas-setup";
import { Canvas } from "fabric";
import { CustomCanvas } from "@/types/fabric";

interface CanvasContainerProps {
  canvasRef: React.RefObject<HTMLCanvasElement>;
  activeTool: Tool;
  showPricing: boolean;
  currentZoom?: number;
}

export const CanvasContainer = ({
  canvasRef,
  activeTool,
  showPricing,
  currentZoom = 100,
}: CanvasContainerProps) => {
  // Initialize canvas with measurement visibility preference
  useEffect(() => {
    const canvasElement = canvasRef.current;
    if (!canvasElement) return;
    
    // Check for canvas instances (fabric doesn't have getInstanceByElement, so we need another approach)
    const fabricCanvas = (Canvas as any)._instances?.find((instance: any) => 
      instance.lowerCanvasEl === canvasElement
    );
    
    if (!fabricCanvas) return;
    
    const customCanvas = fabricCanvas as CustomCanvas;
    
    // Initialize showMeasurements to true if not already set
    if (customCanvas.data && customCanvas.data.showMeasurements === undefined) {
      customCanvas.data.showMeasurements = true;
    }
  }, [canvasRef]);

  return (
    <div
      className={cn(
        "relative w-full h-full bg-white",
        showPricing && "opacity-50 pointer-events-none",
        activeTool === "ruler" && "ruler-cursor",
        activeTool === "angle" && "angle-cursor"
      )}
      data-zoom={currentZoom}
      data-tool={activeTool}
    >
      <div className="absolute inset-0 overflow-auto">
        <canvas ref={canvasRef} className="absolute" id="main-canvas" />
        <CanvasGrid 
          dotSize={1.2} 
          size={18} 
          opacity={0.15} 
          color="#6366f1" 
          animated={true}
          gradientColors={["#3b82f6", "#8b5cf6", "#6366f1"]}
        />
      </div>
    </div>
  );
};
